import React from 'react';
import PropTypes from 'prop-types';

const UserGroup = ({ color = '#B5BDC5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/Billboard/customgroups"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <rect
                id="Rectangle-10"
                stroke="#979797"
                fill="#D8D8D8"
                opacity="0"
                x="0.5"
                y="0.5"
                width="17"
                height="17"
            />
            <path
                d="M12.2727273,7.90909091 C13.6309091,7.90909091 14.7190909,6.81272727 14.7190909,5.45454545 C14.7190909,4.09636364 13.6309091,3 12.2727273,3 C10.9145455,3 9.81818182,4.09636364 9.81818182,5.45454545 C9.81818182,6.81272727 10.9145455,7.90909091 12.2727273,7.90909091 Z M5.72727273,7.90909091 C7.08545455,7.90909091 8.17363636,6.81272727 8.17363636,5.45454545 C8.17363636,4.09636364 7.08545455,3 5.72727273,3 C4.36909091,3 3.27272727,4.09636364 3.27272727,5.45454545 C3.27272727,6.81272727 4.36909091,7.90909091 5.72727273,7.90909091 Z M5.72727273,9.54545455 C3.82090909,9.54545455 0,10.5027273 0,12.4090909 L0,14.4545455 L11.4545455,14.4545455 L11.4545455,12.4090909 C11.4545455,10.5027273 7.63363636,9.54545455 5.72727273,9.54545455 Z M12.2727273,9.54545455 C12.0354545,9.54545455 11.7654545,9.56181818 11.4790909,9.58636364 C12.4281818,10.2736364 13.0909091,11.1981818 13.0909091,12.4090909 L13.0909091,14.4545455 L18,14.4545455 L18,12.4090909 C18,10.5027273 14.1790909,9.54545455 12.2727273,9.54545455 Z"
                id="Icon"
                fill={color}
            />
        </g>
    </svg>
);

UserGroup.propTypes = {
    color: PropTypes.string,
};

export default UserGroup;
